export enum TerminationField {
    ID = "id",
    CUSTOMER_NUMBER = "customerNumber",
    CUSTOMER_NAME = "customerName",
    TERMINATION_AT = "terminationAt",
    IS_FULL_TERMINATION = "isFullTermination",
    DEVICES_PENDING = "devicesPending",
    DEVICES_TOTAL = "devicesTotal",
    STATUS = "status",
    STATUS_CHANGED_AT = "statusChangedAt",
    MAIL_PENDING = "mailPending",
    MAIL_AT = "mailAt",
    ADMIN_MAILS = "adminMails",
    COMMENT = "comment",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt",
    IS_CORRUPTED = "isCorrupted",
}

export enum TerminationStatus {
    OPEN = "OPEN",
    IN_PROGRESS = "IN_PROGRESS",
    PENDING_COMPLETION = "PENDING_COMPLETION",
    DONE = "DONE",
    WITHDRAWN = "WITHDRAWN",
}

export enum TerminationMailType {
    INIT = "INIT",
    REMINDER_1 = "REMINDER_1",
    REMINDER_2 = "REMINDER_2",
    CLOSURE_MISSING = "CLOSURE_MISSING",
    CLOSURE_COMPLETE = "CLOSURE_COMPLETE",
    CLOSURE_WITHDRAWN = "CLOSURE_WITHDRAWN",
}

export interface Termination {
    [TerminationField.ID]: number;
    [TerminationField.CUSTOMER_NUMBER]: string;
    [TerminationField.CUSTOMER_NAME]: string;
    [TerminationField.TERMINATION_AT]: string;
    [TerminationField.IS_FULL_TERMINATION]: boolean;
    [TerminationField.DEVICES_PENDING]: number;
    [TerminationField.DEVICES_TOTAL]: number;
    [TerminationField.STATUS]: TerminationStatus;
    [TerminationField.STATUS_CHANGED_AT]: string;
    [TerminationField.MAIL_PENDING]: TerminationMailType;
    [TerminationField.MAIL_AT]: string;
    [TerminationField.ADMIN_MAILS]: string;
    [TerminationField.COMMENT]: string;
    [TerminationField.CREATED_AT]: string;
    [TerminationField.UPDATED_AT]: string;
    [TerminationField.IS_CORRUPTED]: boolean;
}

export enum TerminationItemField {
    ID = "id",
    TERMINATION_ID = "terminationId",
    HARDWARE_TYPE = "type",
    LEO_ID = "leoId",
    PREDECESSOR_LEO_ID = "predecessorLeoId",
    SERIAL_NUMBER = "serialNumber",
    SHORT_ICCID = "shortIccid",
    RETURN_REQUIRED = "returnRequired",
    RETURN_DATE = "returnDate",
    RETURN_STATUS = "returnStatus",
    TESTED_AT = "testedAt",
    TEST_RESULT = "testResult",
    CANCELLATION_REASON = "cancellationReason",
}

export enum TerminationItemReturnStatus {
    OPEN = "OPEN",
    RECEIVED = "RECEIVED",
    LOST = "LOST",
    OBSOLETE = "OBSOLETE",
    INTERNAL = "INTERNAL",
}

export enum TerminationItemTestResult {
    OPEN = "OPEN",
    QUALITY_A = "QUALITY_A",
    QUALITY_B = "QUALITY_B",
    QUALITY_C = "QUALITY_C",
    BROKEN = "BROKEN",
    OBSOLETE = "OBSOLETE",
}

export interface TerminationItem {
    [TerminationItemField.ID]: number;
    [TerminationItemField.TERMINATION_ID]: number;
    [TerminationItemField.HARDWARE_TYPE]: string;
    [TerminationItemField.LEO_ID]: string;
    [TerminationItemField.PREDECESSOR_LEO_ID]: string;
    [TerminationItemField.SERIAL_NUMBER]: string;
    [TerminationItemField.SHORT_ICCID]: string;
    [TerminationItemField.RETURN_REQUIRED]: boolean;
    [TerminationItemField.RETURN_DATE]: string;
    [TerminationItemField.RETURN_STATUS]: TerminationItemReturnStatus;
    [TerminationItemField.TESTED_AT]: string;
    [TerminationItemField.TEST_RESULT]: TerminationItemTestResult;
    [TerminationItemField.CANCELLATION_REASON]: number;
}

export enum TerminationCommunicationField {
    ID = "id",
    TERMINATION_ID = "terminationId",
    MAIL_TYPE = "mailType",
    SENT_AT = "sentAt",
}

export interface TerminationCommunication {
    [TerminationCommunicationField.ID]: number;
    [TerminationCommunicationField.TERMINATION_ID]: number;
    [TerminationCommunicationField.MAIL_TYPE]: TerminationMailType;
    [TerminationCommunicationField.SENT_AT]: string;
}
